import {sessionStorage} from 'utilities/storage';
import * as URL from 'utilities/URL';
import {tryParse} from 'utilities/parse';
import values from 'lodash/values';

const SWITCHER_KEY = 'domoFeatures';
const STORAGE_KEY = 'featureSwitches';
const QUERY_KEY = '_f';

export const fetchFeaturesFromUrl = () =>
  Promise.resolve().then(() => {
    const query = URL.parseQuerystring();
    const param = query[QUERY_KEY] || '';
    return param
      .split(',')
      .filter(feature => feature.length)
      .reduce((memo, feature) => {
        const sections = feature.split('!', 2);
        const isEnabled = sections.length === 1;
        const name = sections[sections.length - 1];
        memo[name] = isEnabled;
        return memo;
      }, {});
  });

export const fetchFeaturesFromStorage = () =>
  Promise.resolve().then(() => {
    const rawValue = sessionStorage.getItem(STORAGE_KEY) || '{}';
    return tryParse(rawValue, {});
  });

export const addFeaturesToStorage = features =>
  fetchFeaturesFromStorage().then(sessionFeatures => {
    const merged = {...sessionFeatures, ...features};
    return sessionStorage.setItem(STORAGE_KEY, JSON.stringify(merged));
  });

export const fetchFeaturesFromSwitcher = () =>
  Promise.resolve().then(() => {
    const rawValue = sessionStorage.getItem(SWITCHER_KEY) || '{}';
    const featuresObj = tryParse(rawValue, {});
    return values(featuresObj.features).reduce((memo, feature) => {
      memo[feature.name] = feature.enabled;
      return memo;
    }, {});
  });
